import React from "react";
import { useNavigate } from "react-router-dom";
import RotatingLogo from "../../Loaders/RotatingLogo";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";

const WelcomeStep = ({
    userData,
    loading,
    handleStep,
    error,
    loadingSteps
}) => {
    const { t } = useLanguage()

    return (
        <div className="steps_main_container">
            {loading ? (
                <div className="welcome_step_cont">
                    <div className="welcome_step_cont_inner">
                        <RotatingLogo />
                    </div>
                </div>
            ) : (
                <div className="welcome_step_cont">
                    <div className="welcome_step_cont_inner">
                        <p className="step_title fade-in">{t.onboarding.welcome} {userData?.name}! </p>
                        <p className="step_description fade-in">{t.onboarding.welcome_sub}</p>
                        <button className="mainframe_item_create_btn fade-in mainframe_item_create_btn_anim" onClick={() => handleStep("continue", "language")}>
                            {loadingSteps ? (
                                <Spinner loading={true} />
                            ) : (
                                <>{t.onboarding.ready} <i className="fa-solid fa-chevron-right"></i></>
                            )}
                        </button>
                        <ErrorMessage err={error} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default WelcomeStep